import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixPopover from "@radix-ui/react-popover";
import { memo } from "react";
export const comboboxInputTrigger = tailwindVariants({
    base: "flex w-full flex-wrap items-center justify-start gap-2 rounded-4 bg-grey-1 px-2 text-16 text-grey-12 outline-none ring-1 ring-inset ring-grey-5 focus:ring-2 focus:ring-blue-9",
    variants: {
        size: {
            "extra-large": "min-h-[48px] py-3 md:text-16",
            large: "min-h-[40px] py-2 md:text-14",
            medium: "min-h-[32px] py-1 md:text-14",
            small: "min-h-[24px] py-1 md:text-12"
        }
    },
    defaultVariants: {
        size: "medium"
    }
});
export const ComboboxInputTrigger = /*#__PURE__*/ memo((param)=>{
    let { className, size, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixPopover.Trigger, {
        className: comboboxInputTrigger({
            size,
            className
        }),
        "data-testid": "COMBOBOX_INPUT_TRIGGER",
        ...restOfProps
    });
});
ComboboxInputTrigger.displayName = "ComboboxInputTrigger";
